/**
 * Formatters partagés pour dates et durées.
 * Importer depuis n'importe quel composant qui doit afficher des timestamps.
 */

/**
 * Format date courte : "JJ/MM/AA"
 * Pour : inscriptions, dates de création, etc. (info temporelle "macro").
 */
export function formatDate(d) {
    if (!d) return '—';
    return new Date(d).toLocaleDateString('fr-FR', {
        day: '2-digit', month: '2-digit', year: '2-digit'
    });
}

/**
 * Format date + heure : "JJ/MM/AA HH:mm"
 * Pour : timestamps d'activité (dernière session, feedback, redeem, etc.).
 */
export function formatDateTime(d) {
    if (!d) return '—';
    const dt = new Date(d);
    const date = dt.toLocaleDateString('fr-FR', {
        day: '2-digit', month: '2-digit', year: '2-digit'
    });
    const time = dt.toLocaleTimeString('fr-FR', {
        hour: '2-digit', minute: '2-digit'
    });
    return `${date} ${time}`;
}

/**
 * Format durée en secondes → "Xs" / "Xm" / "XhYm"
 * Pour : temps total passé, temps moyen, etc.
 */
export function formatTime(seconds) {
    const s = Number(seconds) || 0;
    if (s < 60) return `${s}s`;
    const m = Math.floor(s / 60);
    if (m < 60) return `${m}m`;
    const h = Math.floor(m / 60);
    return `${h}h${m % 60 ? `${m % 60}m` : ''}`;
}

/**
 * Durée estimée d'une séance : "≈ 4 min" (migration 193).
 * secPerQ = { apprentissage, quiz } secondes par question constatées (scopes/detail.php, sec_per_q).
 * Retourne null sans donnée.
 */
export function estimateSessionDuration(secPerQ, mode, nbQuestions) {
    const s = Number(secPerQ?.[mode]) || 0;
    if (!s || !nbQuestions) return null;
    const min = Math.max(1, Math.round(s * nbQuestions / 60));
    return `≈ ${min} min`;
}
